export const setLocalStorageCostCenterUserAuth = (costCenter) => {
    localStorage.setItem('costCenter', costCenter);
}

export const getLocalStorageCostCenterUserAuth = () => {
    return localStorage.getItem('costCenter');
}   